import {getConfigFields, getMaxLengthConstraint} from '../fields.js'
import {formFieldIds} from '../values.js'

const {plate, additionalTitle, vehicleStatus} = formFieldIds

const formAdditionalSellVehicleFieldsConfig = [
  getConfigFields[additionalTitle](),
  getConfigFields[plate]({
    customProps: {
      constraints: [getMaxLengthConstraint({value: '8'})]
    }
  }),
  getConfigFields[vehicleStatus]()
]

export const formAdditionalSellVehicleConfig = {
  fields: formAdditionalSellVehicleFieldsConfig
}
